import React, { useEffect, useState } from "react";
import {
  CButton,
  CCallout,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CLabel,
  CRow,
} from "@coreui/react";
import { useHistory, useParams } from "react-router-dom";
import ConfirmationPopup from "../common/ConfirmationPopup";
import { apiCall } from "src/_apiConfig/apiCall";

const Selectyourpayment = () => {
  const history = useHistory();
  const { lotTransferId } = useParams("lotTransferId");
  const [amount, setamount] = useState("");
  const [lotno, setlotno] = useState("");
  const [lottransferfee, setlottransferfee] = useState("");
  const [gst, setgst] = useState("");
  const [total, settotal] = useState("");
  //Confirmation popup------------------------------------
  const [CPopUpId, setCPopUpId] = useState();
  const [CPopUpIndex, setCPopUpIndex] = useState();
  const [CPopUpDisplayConfirmationModal, setCPopUpDisplayConfirmationModal] =
    useState(false);
  const [CPopUpBodyText, setCPopUpBodyText] = useState();

  const handleConfirmationPopUpModalClose = () =>
    setCPopUpDisplayConfirmationModal(false);
  //-------------------------------------------------------
  useEffect(() => {
    getLotAmount();
    // reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lotTransferId]);

  const getLotAmount = async () => {
    const header = new Headers();
    header.append("Content-Type", "application/json");
    header.append("Accept", "application/json");
    const response = await apiCall(
      `LotTransfer/getlotamount?lottransferid=${lotTransferId}`,
      "GET",
      header,
      null
    );
    const res = await response.json();
    if (response.status === 200) {
      setamount(res.total);
      setlotno(res.lotNo);
      setlottransferfee(res.lotTransferFee);
      setgst(res.gst);
      settotal(res.total);
      console.log(res);
    } else {
      // TODO handle server error if payment cant proceed
    }
  };

  const ConfirmationPopupHandler = async (
    popupid,
    popupindex,
    popupbodytext
  ) => {
    setCPopUpId(popupid);
    setCPopUpIndex(popupindex);
    setCPopUpDisplayConfirmationModal(true);
    setCPopUpBodyText(popupbodytext);
  };
  const SubmitConfirmationPopUpResponse = async () => {
    PaymentHanlder();
  };
  const PaymentHanlder = async () => {
    history.push(`/submitpayment/${history.location.state.lotId}/${amount}/0`, {
      from: window.location.href,
    });
  };

  const PaymentBGHanlder = async () => {
    // to={`/OfflinePaymentWithType/${lotid}/transferemd`}
    history.push(
      `/OfflinePaymentWithType/${window.btoa(
        history.location.state.lotId
      )}/transferemdfee`,
      {
        from: window.location.href,
      }
    );
  };
  return (
    <CCard className={"shadow-sm"}>
      <CCardHeader>
        <CRow className="pt-3">
          <CCol xl={12}>
            <CCallout color="success">
              <h3>Select Your Payment Method Here</h3>
            </CCallout>
          </CCol>
        </CRow>
      </CCardHeader>

      <CCardBody>
        <CRow className="mb-3">
          <CCol xl={2} className="mr-4 mt-2 ">
            Lot No:
          </CCol>
          <CCol xl={2} className="mr-4 mt-2 ">
            {lotno}
          </CCol>
        </CRow>

        <CRow className="mb-3">
          <CCol xl={2} className="mr-4 mt-2 ">
            Lot Transfer Fee
          </CCol>
          <CCol xl={2} className="mr-4 mt-2 ">
            {lottransferfee}
          </CCol>
        </CRow>

        <CRow className="mb-3">
          <CCol xl={2} className="mr-4 mt-2 ">
            GST
          </CCol>
          <CCol xl={2} className="mr-4 mt-2 ">
            {gst}
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <CCol xl={2} className="mr-4 mt-2 ">
            Total Amount
          </CCol>
          <CCol xl={2} className="mr-4 mt-2 ">
            {total}
          </CCol>
        </CRow>

        <CRow className="mb-3">
          <CCol xl={2} className="mr-4 mt-2 ">
            <CLabel htmlFor="uploaddoc">Payment Type :</CLabel>
          </CCol>
          <CCol xl={2}>
            <CButton
              className="mr-4 mt-2 "
              color="success"
              //onClick={PaymentHanlder}
              onClick={() =>
                ConfirmationPopupHandler(
                  1,
                  -1,
                  "Are you sure you want to pay via online?"
                )
              }
            >
              Online Payment
            </CButton>
          </CCol>
          {/* <CCol xl={2}>
            <CButton
              className="mr-4 mt-2 "
              color="success"
              to={`/offlinepayment/${lotTransferId}`}
            >
              Offline Payment
            </CButton>
          </CCol> */}
          <CCol xl={2}>
            <CButton
              hidden="true"
              className="mr-4 mt-2 "
              onClick={PaymentBGHanlder}
              color="success"
            >
              Bank Guarantee Payment
            </CButton>
          </CCol>
        </CRow>
        <CRow className="">
          <CCol xl={2}>
            <CButton color="dark" onClick={() => history.goBack()}>
              Go Back
            </CButton>
            <div>
              <ConfirmationPopup
                showModal={CPopUpDisplayConfirmationModal}
                hideModal={handleConfirmationPopUpModalClose}
                confirmModal={SubmitConfirmationPopUpResponse}
                id={CPopUpId}
                index={CPopUpIndex}
                ModalBody={CPopUpBodyText}
                // ModalTitle={CPopUpTitle}
                confirmButtonCss="btn btn-danger"
                ButtonLoader={false}
              />
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  );
};
export default Selectyourpayment;
